<template>
  <BModal
    id="modal-daily-limit"
    ref="modal-daily-limit"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="p-1 flex flex-col gap-4 text-[#333333]">
      <h2 class="text-center font-bold text-2xl mb-1 text-[#333333]">
        Naikan Limit Harian Kartu
      </h2>
      <div>
        Limit Harian Kartu Saat ini :
        <span class="font-weight-bold">{{
          IDR(cards.daily_spending_limit, 2, 2)
        }}</span>
      </div>
      <div class="w-full">
        <BFormGroup>
          <template #label>
            <div>
              Ubah Limit Harian Kartu (Rp)<span class="text-primary">*</span>
            </div>
          </template>
          <ValidationProvider
            #default="{ errors }"
            name="Daily Limit"
            :rules="{
              required: true,
              min_value: cards.daily_spending_limit,
              max_value: cards.daily_spending_limit + 25000000,
            }"
          >
            <BFormInput
              id="daily-limit-input"
              v-model="newDailyLimit"
              :state="errors.length > 0 ? false : null"
              placeholder="Ubah limit harian kartu"
              @keypress="isNumber($event)"
              @input="formatCurrency"
            />
            <small
              :class="errors.length > 0 ? 'text-danger' : ''"
              class="float-left mt-[3px]"
            >
              {{ errors[0] }}
            </small>
          </ValidationProvider>
        </BFormGroup>
      </div>
      <div class="d-flex justify-content-between gap-2">
        <BButton
          variant="outline-primary"
          class="grow"
          @click="handleCancel"
        >
          Batal
        </BButton>
        <BButton
          variant="primary"
          :disabled="!isValidLimit || isUpdatingLimit"
          class="grow"
          @click="updateDailyLimit"
        >
          <BSpinner
            v-if="isUpdatingLimit"
            small
          />
          Ubah
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR, IDRWithoutLbl } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'
import { required } from '@validations'
import { BFormGroup, BFormInput, BSpinner } from 'bootstrap-vue'
import { extend, ValidationProvider } from 'vee-validate'

extend('max_value', {
  validate: (value, { max_value }) => {
    const numValue = parseFloat(value.replace(/[^0-9,-]+/g, ''))
    return numValue <= max_value
  },
  params: ['max_value'],
  message: (_, { max_value }) => `Maksimal "Up Daily Limit" saat ini yaitu ${IDR(max_value)}`,
})

extend('min_value', {
  validate: (value, { min_value }) => {
    const numValue = parseFloat(value.replace(/[^0-9,-]+/g, ''))
    return numValue > min_value
  },
  params: ['min_value'],
  message: 'Harus lebih besar dari daily limit saat ini',
})

export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormInput,
    BSpinner,
  },
  props: {
    cards: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      newDailyLimit: '',
      isUpdatingLimit: false,
      IDR,
      isNumber,
    }
  },
  computed: {
    maxAllowedLimit() {
      if (this.cards && typeof this.cards.daily_spending_limit === 'number') {
        return this.cards.daily_spending_limit + 25000000
      }
      return 0
    },

    isValidLimit() {
      if (!this.newDailyLimit) return false
      const numValue = parseFloat(this.newDailyLimit.replace(/[^0-9,-]+/g, ''))
      return (
        numValue > this.cards.daily_spending_limit
        && numValue <= this.maxAllowedLimit
      )
    },
  },
  methods: {
    // Reset the new daily limit input field
    resetForm() {
      this.newDailyLimit = ''
    },

    // Handle cancel button click
    handleCancel() {
      this.resetForm()
      this.$bvModal.hide('modal-daily-limit')
    },
    formatCurrency(value) {
      const numValue = parseFloat(value.replace(/[^0-9,-]+/g, '')) || 0
      this.newDailyLimit = IDRWithoutLbl(numValue)
    },
    async updateDailyLimit() {
      if (!this.isValidLimit) return

      this.isUpdatingLimit = true

      try {
        const limitValue = parseFloat(
          this.newDailyLimit.replace(/[^0-9,-]+/g, ''),
        )

        // API call to update daily limit
        const url = `/komcards/api/v1/card/${this.cards.id}/set-limit`
        await newAxiosIns.put(url, {
          limit: limitValue,
        })

        // Update local data
        this.cards.daily_spending_limit = limitValue

        this.$toast_success({
          message: 'Berhasil ubah limit harian kartu.',
        })

        this.$bvModal.hide('modal-daily-limit')
        this.$emit('update-card-data')
      } catch (error) {
        this.$toast_error({
          title: 'Gagal!',
          message:
            'Gagal ubah limit harian kartu. Periksa koneksi atau coba lagi nanti.',
        })
      } finally {
        this.isUpdatingLimit = false
        this.resetForm()
      }
    },
  },
}
</script>
